import { BiddingSchedule, BiddingScheduleRange } from "@prisma/client";

// Check if the end of the current range can be reached by adding some
// multiple of its increment to the current price.
export const respectsBiddingSchedule = (
    amount: number,
    biddingSchedule: BiddingSchedule & { BiddingScheduleRange: BiddingScheduleRange[] }
) => {
    const sortedRanges = [...biddingSchedule.BiddingScheduleRange].sort(
        (a, b) => a.rangeEnd - b.rangeEnd
    );

    const currentRange = sortedRanges.find((range, idx) => {
        return amount <= range.rangeEnd && (idx === 0 || amount > sortedRanges[idx - 1].rangeEnd);
    });
    if (!currentRange) return false;

    return (currentRange.rangeEnd - amount) % currentRange.increment === 0;
}

// 1 indexed
export const getNthNextBid = (
    currentBid: number,
    biddingSchedule: BiddingSchedule & {
        BiddingScheduleRange: BiddingScheduleRange[];
    } | null,
    n: number
) => {
    if (!biddingSchedule) return currentBid;

    // Just for safety
    const sortedRanges = [...biddingSchedule.BiddingScheduleRange].sort(
        (a, b) => a.rangeEnd - b.rangeEnd
    );

    // Find which range the minBid falls into
    const currentRangeIndex = sortedRanges.findIndex(
        (range, index) =>
            currentBid <= range.rangeEnd &&
            (index === 0 || currentBid > sortedRanges[index - 1].rangeEnd)
    );

    if (currentRangeIndex === -1) {
        // If no range found, use the last range's increment
        const lastRange = sortedRanges[sortedRanges.length - 1];
        return currentBid + lastRange.increment * n;
    }

    let remainingSteps = n;
    let rangeIndex = currentRangeIndex;

    while (remainingSteps > 0 && rangeIndex < sortedRanges.length) {
        const currentRange = sortedRanges[rangeIndex];
        const stepsToPassRangeEnd = Math.ceil((currentRange.rangeEnd + 0.01 - currentBid) / currentRange.increment)
        const stepsInThisRange = Math.min(remainingSteps, stepsToPassRangeEnd);
        // console.log(currentRange.rangeEnd, currentBid, stepsToPassRangeEnd, stepsInThisRange)

        currentBid += currentRange.increment * stepsInThisRange;
        remainingSteps -= stepsInThisRange;

        if (remainingSteps > 0) {
            rangeIndex++;
        }
    }

    return currentBid;
};

export const formatPostalCode = (postalCode: string) => {
    if (!postalCode) return null
    // Check if postal code contains letters (Canadian)
    if (/[a-zA-Z]/.test(postalCode)) {
        return postalCode.slice(0, 3) + ' ' + postalCode.slice(3);
    }
    return postalCode;
}